// Player — состояние одной стороны матча: Герой, рука, колода, сброс, поле, Влияние.
// Поле: 2 линии × 4 слота, line 0 = передняя, line 1 = тыл.

export class Player {
  constructor(id, name, hero, deck) {
    this.id = id;          // 0 — игрок снизу, 1 — бот сверху
    this.name = name;
    this.hero = hero;      // Card (type === 'hero')
    this.hero.ownerId = id;

    this.deck = deck;      // массив Card (24)
    for (const c of this.deck) c.ownerId = id;

    this.hand = [];
    this.discard = [];
    this.influence = 0;            // А.4.4.1: 0..10, прибавляется через addInfluence()
    this.heroActiveUsed = false;   // А.4.4.1: 1-раз-за-матч флаг для активки Героя
    // В.1.g-fix2: Стратег Ли Пул — флаг «уже использовал перемещение в этой Ф4».
    // Взаимоисключение с heroAttackedThisTurn. Сбрасывается в startTurn / EOT.
    this.heroMovedUnitThisTurn = false;

    // А.4.4.2: карты Влияния. Парашют активен «на защите».
    this.parachuteActive = false;
    // Иммунитет Героя до конца указанного хода (включительно). null — нет иммунитета.
    this.heroImmuneUntilTurn = null;
    // Действие, выбранное в Ф2 для розыгрыша в Ф3.
    // { cardInstanceId, targetInstanceId|null, targetSide:0|1|null }
    this.pendingAction = null;
    // Запретить получать Влияние в этом ходу (Манипуляция фондовым рынком).
    // turn-id, до конца которого Влияние блокируется (включительно).
    this.blockInfluenceUntilTurn = null;
    // А.4.4.4: extra plays — дополнительные размещения в следующей Ф2 (Аудитор, Интендант, Совет).
    this.extraPlaysNextTurn = 0;
    // Б.1.c: счётчик сыгранных Модов за матч (Синтетикс).
    // НЕ сбрасывается в конце хода. Используется для прогрессирующего урона Герою.
    this.modPlaysCount = 0;
    // Б.2.d-fix1: эффект Инициатора (Б.2.d). null означает "не активен".
    // Инициализируем явно, чтобы все проверки (canAddPlacement, placementBudget,
    // getAvailablePlacements, revealPendingMods, isInitiatorActive) видели
    // null вместо undefined и не цеплялись о возможные ошибки доступа.
    this.activeInitiatorEffect = null;

    // C.1 Этап 33: оффер карт Влияния (3 случайные) и счётчик розыгрышей по картам.
    // Roll происходит в startTurn для Деус-Героев. Лимит 2 копии за матч.
    this.influenceOffer = [];
    this.influencePlayCounts = {};

    // Поле: [line0[4], line1[4]], каждая ячейка — Card | null
    this.field = [
      [null, null, null, null],
      [null, null, null, null]
    ];
  }

  // Возвращает все живые юниты на поле в порядке: line 0 слева-направо, потом line 1.
  unitsOnField() {
    const out = [];
    for (let l = 0; l < 2; l++) {
      for (let s = 0; s < 4; s++) {
        const c = this.field[l][s];
        if (c && c.isAlive()) out.push(c);
      }
    }
    return out;
  }

  // Есть ли свободные слоты на поле (хотя бы один).
  hasFreeSlot() {
    for (let l = 0; l < 2; l++) {
      for (let s = 0; s < 4; s++) {
        if (this.field[l][s] === null) return true;
      }
    }
    return false;
  }

  // Список свободных слотов: [{line, slot}].
  freeSlots() {
    const out = [];
    for (let l = 0; l < 2; l++) {
      for (let s = 0; s < 4; s++) {
        if (this.field[l][s] === null) out.push({ line: l, slot: s });
      }
    }
    return out;
  }

  // Положить карту в слот.
  placeCard(card, line, slot) {
    if (this.field[line][slot] !== null) {
      throw new Error(`Слот ${line}/${slot} уже занят`);
    }
    card.line = line;
    card.slot = slot;
    card.ownerId = this.id;
    this.field[line][slot] = card;
  }

  // Убрать карту с поля (после смерти) — в сброс.
  // Б.2.a: сохраняем последнее место в lastLine/lastSlot — нужно для воскрешения
  // через Второе сердце (возврат на ту же ячейку, если свободна).
  removeFromField(card) {
    if (card.line === null || card.slot === null) return;
    if (this.field[card.line][card.slot] === card) {
      this.field[card.line][card.slot] = null;
    }
    card.lastLine = card.line;
    card.lastSlot = card.slot;
    card.line = null;
    card.slot = null;
    card.alive = false;
    this.discard.push(card);
  }

  // Тяга карты с верха колоды. Возвращает Card | null.
  drawOne() {
    return this.deck.length > 0 ? this.deck.shift() : null;
  }
}
